export enum PERMISSION {
  manageAllSectionChangeRequests = "manageAllSectionChangeRequests",
  manageOwnSectionChangeRequests = "manageOwnSectionChangeRequests",
  manageOwnSectionChangeRequestSettings = "manageOwnSectionChangeRequestSettings",
  viewMemberContributions = "viewMemberContributions",
  viewSponsorContributions = "viewSponsorContributions",
  viewGrpEnrollments = "viewGrpEnrollments",
  viewGrpCommission = "viewGrpCommission",
  manageGrpCommission = "manageGrpCommission",
  manageGrpAuthorizations = "manageGrpAuthorizations",
  viewOrders = "viewOrders",
  viewPayments = "viewPayments",
  manageOrders = "manageOrders",
  managePayments = "managePayments",
  markOrdersUncollectible = "markOrdersUncollectible",
  viewPeople = "viewPeople",
  viewPersonContact = "viewPersonContact",
  viewPersonMembership = "viewPersonMembership",
  viewPersonSuspensionHistory = "viewPersonSuspensionHistory",
  viewPersonEducation = "viewPersonEducation",
  viewPersonCareer = "viewPersonCareer",
  viewPersonEvents = "viewPersonEvents",
  viewPersonBilling = "viewPersonBilling",
  viewPersonNotes = "viewPersonNotes",
  viewPersonGroups = "viewPersonGroups",
  viewPersonChangeHistory = "viewPersonChangeHistory",
  viewPersonDocuments = "viewPersonDocuments",
  viewTaxDocuments = "viewTaxDocuments",
  uploadTaxDocuments = "uploadTaxDocuments",
  publishTaxDocuments = "publishTaxDocuments",
  deleteTaxDocuments = "deleteTaxDocuments",
  viewPersonInsights = "viewPersonInsights",
  viewSection = "viewSection",
  managePeople = "managePeople",
  viewFacilities = "viewFacilities",
  createFacilities = "createFacilities",
  manageFacilities = "manageFacilities",
  editFacilitySection = "editFacilitySection",
  manageVideos = "manageVideos",
  manageUniversities = "manageUniversities",
  viewPeopleInteractions = "viewPeopleInteractions",
  managePeopleInteractions = "managePeopleInteractions",
  manageEvents = "manageEvents",
  managePAT = "managePAT",
  editPAT = "editPAT",
  manageRecruitmentActivities = "manageRecruitmentActivities",
  managePATActivities = "managePATActivities",
  manageNationalActivities = "manageNationalActivities",
  manageChampionshipActivities = "manageChampionshipActivities",
  manageEducationActivities = "manageEducationActivities",
  manageEducationPrograms = "manageEducationPrograms",
  deleteEducationProgramLevels = "deleteEducationProgramLevels",
  viewJobPosts = "viewJobPosts",
  viewJobPostDetails = "viewJobPostDetails",
  manageJobPosts = "manageJobPosts",
  viewCareerServicesDashboard = "viewCareerServicesDashboard",
  viewAssociateDashboard = "viewAssociateDashboard",
  viewMemberDashboard = "viewMemberDashboard",
  viewRosterDashboard = "viewRosterDashboard",
  viewDuesRate = "viewDuesRate",
  manageDuesRates = "manageDuesRates",
  editSSN = "editSSN",
  editDOB = "editDOB",
  viewFullDOB = "viewFullDOB",
  viewFullSSN = "viewFullSSN",
  viewPartialSSN = "viewPartialSSN",
  manageEventRegistrationParentalConsent = "manageEventRegistrationParentalConsent",
  editLastName = "editLastName",
  manageParticipations = "manageParticipations",
  manageLegacyPdrCredits = "manageLegacyPdrCredits",
  viewCareerPreferences = "viewCareerPreferences",
  viewCareerPlan = "viewCareerPlan",
  manageCareerPlan = "manageCareerPlan",
  manageAchievements = "manageAchievements",
  viewCompensationProfiles = "viewCompensationProfiles",
  manageCompensationProfiles = "manageCompensationProfiles",
  manageCareerPreferences = "manageCareerPreferences",
  manageFacilityRoles = "manageFacilityRoles",
  viewRecruitingEventRecaps = "viewRecruitingEventRecaps",
  manageEmployments = "manageEmployments",
  manageNonMemberEmployments = "manageNonMemberEmployments",
  manageMemberBands = "manageMemberBands",
  deleteMemberBands = "deleteMemberBands",
  manageChapters = "manageChapters",
  manageSuspensions = "manageSuspensions",
  manageSuspensionsRestricted = "manageSuspensionsRestricted",
  manageRecruitmentLeads = "manageRecruitmentLeads",
  editEmail = "editEmail",
  viewTasks = "viewTasks",
  manageTasks = "manageTasks",
  manageTaskNotificationPreferences = "manageTaskNotificationPreferences",
  manageApplications = "manageApplications",
  manageLifelongLearningApplications = "manageLifelongLearningApplications",
  viewCommittees = "viewCommittees",
  manageCommittees = "manageCommittees",
  sendHQGroupEmail = "sendHQGroupEmail",
  manageMergePurge = "manageMergePurge",
  viewBeneficiaries = "viewBeneficiaries",
  manageBeneficiaries = "manageBeneficiaries",
  viewMemberBenefits = "viewMemberBenefits",
  manageMemberBenefits = "manageMemberBenefits",
  viewPartialBackgroundCheck = "viewPartialBackgroundCheck",
  viewFullBackgroundCheck = "viewFullBackgroundCheck",
  manageBackgroundCheck = "manageBackgroundCheck",
  createBackgroundCheckOrder = "createBackgroundCheckOrder",
  manageOwnUniversity = "manageOwnUniversity",
  manageAllUniversities = "manageAllUniversities",
  assumeUser = "assumeUser"
}

export enum DOMAIN {
  GRP = "benefit_programs",
  EDUCATION = "education",
  BENEFIT_PROGRAMS = "benefit_programs",
  SECTIONS = "sections",
  COMMERCE = "commerce",
  PEOPLE = "people",
  FACILITIES = "facilities",
  EVERYONE = "EVERYONE",
  JOBS = "jobs",
  UNIVERSITIES = "universities",
  EVENTS = "events",
  TASKS = "tasks",
  ACHIEVEMENTS = "achievements"
}

export interface Capability {
  domains: DOMAIN[];
  permissions: PERMISSION[];
}

export type CareerConsultantSection = {
  id: string;
  name: string;
  legacyId: string | null;
};

export enum ROLE {
  // Staff Department Roles
  CAREER_SERVICES_STAFF = "career_services_staff",
  COREBRIDGE_STAFF = "corebridge_staff",
  RECRUITING_STAFF = "recruiting_staff",
  EDUCATION_STAFF = "education_staff",
  FINANCE_STAFF = "finance_staff",
  MEMBERSHIP_SERVICES_STAFF = "membership_services_staff",
  PGA_MAGAZINE_STAFF = "pga_magazine_staff",
  PLAYER_ENGAGEMENT_STAFF = "player_engagement_staff",
  SECTION_STAFF = "section_staff",
  TECHNOLOGY_STAFF = "technology_staff",
  UNIVERSITY_STAFF = "university_staff",

  // Additional Elevated Roles
  CAREER_SERVICES_ADMIN = "career_services_admin",
  EDUCATION_ADMIN = "education_admin",
  FINANCE_ADMIN = "finance_admin",
  MEMBERSHIP_SERVICES_ADMIN = "membership_services_admin",
  SECTION_ADMIN = "section_admin",
  HQ_STAFF = "hq_staff",

  // All-Permission Role
  GLOBAL_ADMIN = "global_admin",

  // Single - Permission Roles
  CRM_FULL_DOB = "crm_full_dob",
  CRM_FULL_SSN = "crm_full_ssn"
}
